import 'remodal'
;(function ($) {
	'use strict'

	// Store the provider listing URL so the detail page back button can return here.
	if ($('.wp-block-ardent-health-providers').length) {
		sessionStorage.setItem('providerListUrl', window.location.href)
	}

	// --- Phone number formatter ---
	function formatPhone(phone) {
		var digits = phone.replace(/\D/g, '')
		return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
	}

	// --- Book Appointment modal ---
	var $bookModal = $('[data-remodal-id=providers-book-appointment-modal]')
	var bookModalInst = null

	if ($bookModal.length) {
		bookModalInst = $bookModal.remodal({ hashTracking: false })
	}

	$(document).on('click', '.provider__item__book-button', function (e) {
		e.preventDefault()
		if (!bookModalInst) return

		var npi = $(this).data('npi')
		var $block = $(this).closest('.wp-block-ardent-health-providers')
		var providers = $block.data('ardentProviders')
		if (!providers || !providers.settings || !providers.settings.providers) return

		var provider = providers.settings.providers.find(function (p) {
			return String(p.entityId) === String(npi)
		})
		if (!provider) return

		$bookModal.find('.providers-modal__provider-name').text(provider.providerName)

		var url = provider.appointmentUrl || ''
		var hasScheduling = url.indexOf('scheduling') !== -1
		var hasMychart = url.indexOf('mychart') !== -1

		var $newPatientSection = $bookModal.find('.providers-modal__new-patient-section')
		var $newPatientBtn = $bookModal.find('.providers-modal__new-patient-btn')
		var $establishedBtn = $bookModal.find('.providers-modal__established-patient-btn')

		if (hasScheduling) {
			// scheduling URL → New Patient button links to it
			$newPatientBtn.attr('href', url).attr('target', '_blank').text('New Patient')
			$newPatientSection.show()
			$establishedBtn.text('Established Patient')
		} else if (hasMychart && provider.appointmentPhone) {
			// mychart URL → first button is Call; second becomes Schedule Online
			$newPatientBtn
				.attr('href', 'tel:' + provider.appointmentPhone.replace(/\D/g, ''))
				.removeAttr('target')
				.text('Call ' + formatPhone(provider.appointmentPhone))
			$newPatientSection.show()
			$establishedBtn.text('Schedule Online')
		} else {
			// no usable URL → hide new patient section, generic established label
			$newPatientSection.hide()
			$establishedBtn.text('Established Patient')
		}

		bookModalInst.open()
	})
})(jQuery)

// eslint-disable-next-line no-unused-vars
;(function ($) {
	/**
	 * Mobile Filters Manager for Ardent Providers
	 * Works with the ardentProviders plugin's state management
	 */
	class MobileProviderFiltersManager {
		constructor($container, pluginInstance) {
			this.$container = $container
			this.plugin = pluginInstance
			this.maxFilter = this.plugin.settings.maxVisibleFilters || 5
			this.cache = {}
		}

		/**
		 * Initialize mobile filters
		 */
		init() {
			if (!this.validate()) {
				return this
			}

			this.setupOffCanvasStructure()
			this.buildMobileFilters()
			this.createFilterToggleButton()
			this.setupEventListeners()

			// Sync with URL (which populates state.activeFilters)
			this.plugin.syncWithURL(false)

			return this
		}

		/**
		 * Validate plugin instance and settings
		 */
		validate() {
			if (!this.plugin || !this.plugin.state || !this.plugin.settings) {
				console.warn('MobileProviderFiltersManager: Invalid plugin instance')
				return false
			}

			if (!this.plugin.settings.filters || Object.keys(this.plugin.settings.filters).length === 0) {
				console.warn('MobileProviderFiltersManager: No filters configured')
				return false
			}

			return true
		}

		/**
		 * Setup off-canvas wrapper structure
		 */
		setupOffCanvasStructure() {
			const $overlay = $('<div class="js-off-canvas-overlay is-overlay-fixed is-closable"></div>')
			this.$container.append($overlay)

			$overlay.on('click', () => {
				this.closeOffCanvas()
			})

			this.cache.$overlay = $overlay
		}

		/**
		 * Build all mobile filters
		 */
		buildMobileFilters() {
			const filtersFrag = document.createDocumentFragment()

			Object.values(this.plugin.settings.filters).forEach(filter => {
				if (filter.enabled) {
					const filterElement = this.createFilter(filter)
					filtersFrag.appendChild(filterElement)
				}
			})

			const mobileFilters = this.createMobileFiltersContainer()
			mobileFilters.appendChild(filtersFrag)

			this.addShowResultsButtons(mobileFilters)

			this.$container.append(mobileFilters)
			this.cache.$mobileFilters = $(mobileFilters)
		}

		/**
		 * Create mobile filters container
		 */
		createMobileFiltersContainer() {
			const container = document.createElement('div')
			container.classList.add('provider__mobile-filters')
			container.setAttribute('id', 'provider-filters-canvas')
			return container
		}

		/**
		 * Create a single filter section
		 */
		createFilter(filter) {
			const el = document.createElement('div')
			el.classList.add('provider-filters__' + filter.dataFilter, 'provider-filter')

			const filterFrag = document.createDocumentFragment()

			const header = this.createFilterHeader(filter)
			filterFrag.appendChild(header)

			const list = this.createFilterList(filter)
			filterFrag.appendChild(list)

			if (filter.data.length > this.maxFilter) {
				const toggle = this.createShowMoreToggle(filter)
				filterFrag.appendChild(toggle)
			}

			el.appendChild(filterFrag)
			return el
		}

		/**
		 * Create filter header with title and clear button
		 */
		createFilterHeader(filter) {
			const filterHeader = document.createElement('div')
			filterHeader.classList.add('provider-filters__heading')
			filterHeader.setAttribute('id', 'mobile-' + filter.dataFilter + '-heading')

			const filterHeading = document.createElement('h5')
			filterHeading.appendChild(document.createTextNode(filter.title))
			filterHeader.appendChild(filterHeading)

			const headingFilterClear = document.createElement('span')
			headingFilterClear.classList.add('filter__clear', 'hide')
			headingFilterClear.dataset.filter = filter.dataFilter
			headingFilterClear.appendChild(document.createTextNode('Clear'))
			headingFilterClear.addEventListener('click', () => {
				this.plugin.clearFilter(headingFilterClear.dataset.filter, false)
				this.syncFromState()
			})
			filterHeader.appendChild(headingFilterClear)

			return filterHeader
		}

		/**
		 * Create filter list with radio buttons
		 */
		createFilterList(filter) {
			const filterList = document.createElement('div')
			filterList.classList.add('provider-filters__filters')

			filter.data.forEach((item, index) => {
				const itemInputField = this.createFilterItem(filter, item, index)
				filterList.appendChild(itemInputField)
			})

			return filterList
		}

		/**
		 * Create individual filter item
		 */
		createFilterItem(filter, item, index) {
			const itemId = 'mobile-' + filter.dataFilter + '-' + item.key

			const itemInputField = document.createElement('label')
			itemInputField.htmlFor = itemId
			itemInputField.classList.add(filter.dataFilter + '-filter', 'provider-filters__filter')

			const itemRadio = document.createElement('input')
			itemRadio.type = 'radio'
			itemRadio.name = 'mobile-' + filter.dataFilter
			itemRadio.value = item.key
			itemRadio.id = itemId

			const isActive = this.plugin.state.activeFilters[filter.dataFilter] === item.key
			itemRadio.checked = isActive

			itemRadio.addEventListener('change', () => {
				const filterName = itemRadio.name.replace('mobile-', '')
				this.plugin.setFilter(filterName, itemRadio.value, false)
				this.syncFromState()
			})

			const itemLabel = document.createElement('span')
			itemLabel.appendChild(document.createTextNode(item.value))

			itemInputField.appendChild(itemRadio)
			itemInputField.appendChild(itemLabel)

			if (index >= this.maxFilter) {
				itemInputField.setAttribute('data-show', 'more')
				itemInputField.classList.add('hide')
			}

			itemInputField.setAttribute('data-filter-visible', 'show')

			return itemInputField
		}

		/**
		 * Create show more/less toggle
		 */
		createShowMoreToggle(filter) {
			const itemShowMore = document.createElement('div')
			itemShowMore.classList.add('show-more-' + filter.dataFilter, 'provider-filters__toggle')

			const itemShowMoreLink = document.createElement('a')
			itemShowMoreLink.appendChild(document.createTextNode('Show More'))
			itemShowMoreLink.setAttribute('data-toggle', 'more')
			itemShowMoreLink.addEventListener('click', e => {
				this.plugin.toggleFilterVisibility(e, itemShowMoreLink, 'mobile-' + filter.dataFilter)
			})

			itemShowMore.appendChild(itemShowMoreLink)
			return itemShowMore
		}

		/**
		 * Sync clear button visibility based on state
		 */
		syncClearButtonState(filterName) {
			const hasActiveFilter = filterName in this.plugin.state.activeFilters
			const $clearBtn = $(`.provider__mobile-filters .filter__clear[data-filter="${filterName}"]`)

			if (hasActiveFilter) {
				$clearBtn.removeClass('hide')
			} else {
				$clearBtn.addClass('hide')
			}
		}

		/**
		 * Add "Show Results" buttons at top and bottom
		 */
		addShowResultsButtons(container) {
			const createButton = () => {
				const button = document.createElement('button')
				button.classList.add('button', 'filter', 'hide-for-medium')
				button.appendChild(document.createTextNode('Show Results'))
				button.addEventListener('click', () => {
					this.closeOffCanvas()
					this.scrollToResults()
				})
				return button
			}

			container.insertBefore(createButton(), container.firstChild)
			container.appendChild(createButton())
		}

		/**
		 * Create filter toggle button
		 */
		createFilterToggleButton() {
			const $button = $('<button>Filters</button>')
				.addClass('button filter hide-for-medium')
				.on('click', () => {
					this.openOffCanvas()
				})

			$('.provider__listings').prepend($button)
			this.cache.$filterToggle = $button
		}

		/**
		 * Setup event listeners for plugin changes
		 */
		setupEventListeners() {
			this.$container.on('filterChanged', () => {
				this.syncFromState()
			})

			this.$container.on('filterCleared', () => {
				this.syncFromState()
			})

			this.$container.on('filtersCleared', () => {
				this.syncFromState()
			})
		}

		/**
		 * Initialize Foundation off-canvas (no longer used — replaced with CSS transitions)
		 */
		initializeFoundation() {
			// No-op — Foundation off-canvas replaced with pure CSS/jQuery solution
		}

		/**
		 * Open off-canvas menu — pure CSS/jQuery, no Foundation dependency
		 */
		openOffCanvas() {
			this.cache.$overlay.addClass('is-visible')
			if (this.cache.$mobileFilters) {
				this.cache.$mobileFilters.addClass('is-open')
				this.syncFromState()
			}
		}

		/**
		 * Close off-canvas menu — pure CSS/jQuery, no Foundation dependency
		 */
		closeOffCanvas() {
			this.cache.$overlay.removeClass('is-visible')
			if (this.cache.$mobileFilters) {
				this.cache.$mobileFilters.removeClass('is-open')
			}
		}

		/**
		 * Scroll to results section
		 */
		scrollToResults() {
			this.plugin.scrollToStats()
		}

		/**
		 * Sync mobile filters from plugin state
		 */
		syncFromState() {
			Object.values(this.plugin.settings.filters).forEach(filter => {
				if (!filter.enabled) return

				const activeValue = this.plugin.state.activeFilters[filter.dataFilter]
				const filteredProviders = this.plugin.getFilteredProviders()

				const available = []
				const unavailable = []

				if (activeValue) {
					filter.data.forEach(item => {
						const mobileRadio = document.getElementById(`mobile-${filter.dataFilter}-${item.key}`)
						if (mobileRadio) {
							if (item.key === activeValue) {
								available.push(mobileRadio)
							} else {
								unavailable.push(mobileRadio)
							}
						}
					})
				} else {
					filter.data.forEach(item => {
						const hasProviders = filteredProviders.some(provider => {
							const filterValue = provider[filter.dataFilter]
							return Array.isArray(filterValue)
								? filterValue.includes(item.key)
								: String(filterValue) === item.key
						})

						const mobileRadio = document.getElementById(`mobile-${filter.dataFilter}-${item.key}`)
						if (mobileRadio) {
							if (hasProviders) {
								available.push(mobileRadio)
							} else {
								unavailable.push(mobileRadio)
							}
						}
					})
				}

				const $container = $(
					`.provider__mobile-filters .provider-filters__${filter.dataFilter} .provider-filters__filters`
				)

				if (!$container.length) return

				const $showMoreLink = $(`.provider__mobile-filters .show-more-${filter.dataFilter} a`)
				const showMore = $showMoreLink.length ? $showMoreLink.data('toggle') : 'more'

				let filterLoop = 0

				available.forEach(radio => {
					const $radio = $(radio)
					const $label = $radio.parent()

					$radio.prop('disabled', false).prop('checked', radio.value === activeValue)
					$label.removeClass('disabled').removeClass('fadeIn').removeClass('fadeOut')

					if (filterLoop >= this.maxFilter) {
						$label.attr('data-show', showMore)
						$label.toggleClass('hide', showMore === 'more')
					} else {
						$label.attr('data-show', '').removeClass('hide')
					}

					$container.append($label)
					filterLoop++
				})

				unavailable.forEach(radio => {
					const $radio = $(radio)
					const $label = $radio.parent()

					$radio.prop('disabled', true).prop('checked', false)
					$label.addClass('disabled').removeClass('fadeIn').removeClass('fadeOut')

					if (filterLoop >= this.maxFilter) {
						$label.attr('data-show', showMore)
						$label.toggleClass('hide', showMore === 'more')
					} else {
						$label.attr('data-show', '').removeClass('hide')
					}

					$container.append($label)
					filterLoop++
				})

				this.syncClearButtonState(filter.dataFilter)
			})
		}

		/**
		 * Get current active filters from state
		 */
		getActiveFilters() {
			return { ...this.plugin.state.activeFilters }
		}

		/**
		 * Clean up and destroy
		 */
		destroy() {
			this.$container.off('filterChanged')
			this.$container.off('filterCleared')
			this.$container.off('filtersCleared')

			if (this.cache.$filterToggle) {
				this.cache.$filterToggle.off().remove()
			}

			if (this.cache.$overlay) {
				this.cache.$overlay.off().remove()
			}

			if (this.cache.$mobileFilters) {
				this.cache.$mobileFilters.find('*').off()
				this.cache.$mobileFilters.remove()
			}

			this.cache = {}
		}
	}

	/**
	 * Initialize mobile filters
	 */
	function initArdentProviderMobileFilters() {
		const $container = $('.wp-block-ardent-health-providers')

		if (!$container.length) {
			console.warn('Ardent Providers container not found')
			return null
		}

		const pluginInstance = $container.data('ardentProviders')

		if (!pluginInstance) {
			console.warn('Ardent Providers plugin not initialized')
			return null
		}

		if (!pluginInstance.state || typeof pluginInstance.state.activeFilters === 'undefined') {
			console.error('MobileProviderFiltersManager requires the plugin with state management')
			return null
		}

		const mobileFilters = new MobileProviderFiltersManager($container, pluginInstance)
		mobileFilters.init()

		$container.data('ardentProviderMobileFilters', mobileFilters)

		return mobileFilters
	}

	// Listen for the event if script loads before plugin initialises
	$('.wp-block-ardent-health-providers').on('providersLoaded', function () {
		initArdentProviderMobileFilters()
	})

	// Fallback: if plugin already initialised before this script loaded
	$(document).ready(function () {
		const $container = jQuery('.wp-block-ardent-health-providers')
		if (
			$container.length &&
			$container.data('ardentProviders') &&
			!$container.data('ardentProviderMobileFilters')
		) {
			initArdentProviderMobileFilters()
		}
	})

	// Last resort: short delay to catch any remaining timing edge cases
	setTimeout(function () {
		const $container = jQuery('.wp-block-ardent-health-providers')
		if (
			$container.length &&
			$container.data('ardentProviders') &&
			!$container.data('ardentProviderMobileFilters')
		) {
			initArdentProviderMobileFilters()
		}
	}, 500)
})(jQuery)
